var map = {
	"./9Players/GameBoard": [
		472,
		472
	],
	"./9Players/GameBoard.jsx": [
		472,
		472
	],
	"./9Players/GameRules": [
		277,
		277
	],
	"./9Players/GameRules.jsx": [
		277,
		277
	],
	"./9Players/Main": [
		259,
		259
	],
	"./9Players/Main.jsx": [
		259,
		259
	],
	"./9Players/Player": [
		424,
		43
	],
	"./9Players/Player.jsx": [
		424,
		43
	],
	"./9Players/assets/svgs": [
		201,
		201
	],
	"./9Players/assets/svgs.jsx": [
		201,
		201
	],
	"./9Players/components/ConfirmModal": [
		26
	],
	"./9Players/components/ConfirmModal.jsx": [
		26
	],
	"./9Players/constants/constants": [
		772,
		391
	],
	"./9Players/constants/constants.jsx": [
		772,
		391
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 292;
module.exports = webpackAsyncContext;